// Link popup functionality for preview popup

import { escapeHtml } from '../../../../../modules/files/file-list.utils.js';
import { getPreviewState, setPreviewState } from '../state.js';
import { showCopyToast } from './toasts.js';

export function showLinkPopup(url) {
	// Auto-pin preview when showing link popup to prevent it from closing
	const state = getPreviewState();
	if (state.previewPopupElement && state.previewPopupElement.length) {
		// Clear any pending timeout that might close the preview
		if (state.previewPopupTimeout) {
			clearTimeout(state.previewPopupTimeout);
			state.previewPopupTimeout = null;
		}
		
		// Set preview as hovered to prevent auto-close
		state.previewPopupHovered = true;
		
		// Pin the preview if not already pinned
		if (!state.previewPopupPinned) {
			state.previewPopupPinned = true;
			const pinButton = state.previewPopupElement.find('.preview-popup__pin');
			if (pinButton.length > 0) {
				// Update pin button visual state
				pinButton.addClass('preview-popup__pin--pinned');
				pinButton.attr('aria-label', 'Unpin preview');
				pinButton.attr('title', 'Unpin preview');
				pinButton.find('i').removeClass('bi-pin').addClass('bi-pin-angle-fill');
			}
		}
		setPreviewState(state);
	}

	// Remove existing link popup if any
	$('.preview-popup__link-popup').remove();

	const linkPopupHtml = `
		<div class="preview-popup__link-popup">
			<div class="preview-popup__link-popup-content">
				<div class="preview-popup__link-popup-header">
					<span>Copy link</span>
					<button class="preview-popup__link-popup-close" aria-label="Close">
						<i class="bi bi-x-lg"></i>
					</button>
				</div>
				<div class="preview-popup__link-popup-body">
					<input type="text" class="preview-popup__link-input" value="${escapeHtml(url)}" readonly>
					<button class="preview-popup__link-copy-btn" aria-label="Copy">
						<i class="bi bi-clipboard"></i>
						<span>Copy</span>
					</button>
				</div>
			</div>
		</div>
	`;

	$('body').append(linkPopupHtml);
	const $popup = $('.preview-popup__link-popup');
	const $input = $popup.find('.preview-popup__link-input');
	const $copyBtn = $popup.find('.preview-popup__link-copy-btn');

	// Select text on focus
	$input.on('focus', function() {
		$(this).select();
	});

	// Close button
	$popup.find('.preview-popup__link-popup-close').on('click', function() {
		closeLinkPopup();
	});

		// Copy button
		$copyBtn.on('click', async function() {
			$input.select();
			try {
				if (navigator.clipboard && navigator.clipboard.writeText) {
					await navigator.clipboard.writeText(url);
				} else {
					const success = document.execCommand('copy');
					if (!success) throw new Error('execCommand failed');
				}

				// Show toast notification
				showCopyToast();

				// Close popup after short delay
				setTimeout(() => {
					closeLinkPopup();
				}, 500);
			} catch (err) {
				console.error('[Preview] Failed to copy from popup:', err);
				// Keep input selected so user can manually copy
				$input.select();
			}
		});

	// Close on click outside
	$popup.on('click', function(e) {
		if ($(e.target).hasClass('preview-popup__link-popup')) {
			closeLinkPopup();
		}
	});

	// Show popup with animation
	setTimeout(() => {
		$popup.addClass('preview-popup__link-popup--visible');
		$input.select();
	}, 10);
}

export function closeLinkPopup() {
	const $popup = $('.preview-popup__link-popup');
	if ($popup.length > 0) {
		$popup.fadeOut(200, function() {
			$(this).remove();
		});
	}
}
